import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBQnlfxk5IYzn2gx_GAB8gagLyLrtIE9TU",
  authDomain: "inventaire-u-prod.firebaseapp.com",
  projectId: "inventaire-u-prod",
  storageBucket: "inventaire-u-prod.firebasestorage.app",
  messagingSenderId: "1055953165585",
  appId: "1:1055953165585:web:41aa3680be5e791ff800b0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
